<template>
<div class="scrolly-content-image">
  <img :src="getSource(this.attributes.background)" />
</div>
</template>

<script>
export default {
  props: ['attributes', 'index', 'enter'],
  computed: {
    isTabletWidth () {
      return this.$window.innerWidth < 768
    },
    hasDesktopSource () {
      const {hasdesktop} = this.attributes
      return !hasdesktop || hasdesktop !== 'false'
    }
  },
  methods: {
    getImagePath (index) {
      let [root, ext = 'jpg'] = this.attributes.background.split('.')
      return root + index + '.' + ext
    },
    getImageStyle (index) {
      return {
        opacity: index === 1 ? 1 : this.enter(index - 1, 200)
      }
    },
    getSource (index) {
      const {isTabletWidth, hasDesktopSource} = this
      let [path, ext] = this.attributes.background.split('.')
      path += (!isTabletWidth && hasDesktopSource ? '-desktop.' : '.') + ext
      return require(`images/${path}`)
    }
  }
}
</script>

<style lang="scss">
.scrolly-content-image {
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}
</style>
